import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '@core/auth';
import { AppConfigurations } from '@core/models/app.configurations';
import { KeycloakService } from 'keycloak-angular';
import { interval, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class AppConfigurationsService {
  private configurations: AppConfigurations;
  userDetails: any;

  constructor(private http: HttpClient, private authService: AuthService, private keycloakService: KeycloakService) {
  }

  get configs(): AppConfigurations {
    return this.configurations;
  }

  load() {
    let solutionName = this.getQueryParameterByName('solution') || 'default'
    if (solutionName == 'cquest') solutionName = 'co2storage';
    if (solutionName == 'ds365' || solutionName == 'essentials') {
      solutionName = 'default'
    };
    const promise = this.http
      .get(`/users/configurations/clientSideConfigurations/${solutionName}`)
      .toPromise();

    promise.then((configs: AppConfigurations) => {
      this.configurations = configs
    });
    return promise;
  }

  async initKeycloak(): Promise<boolean> {
    const authenticated = await this.keycloakService.init({
      initOptions: {
        onLoad: 'login-required',
        checkLoginIframe: false
      },
      config: 'keycloak.json'
    });
    console.log('[KEYCLOAK] init success, authenticated =', authenticated);
    return authenticated;

  }

  currentUser() {
    const loggedIn = this.keycloakService.isLoggedIn();
    if (loggedIn) {
      this.keycloakService.getToken().then(token => {
        this.authService.setToken(token);
      });

      interval(180000).subscribe(() => {
        console.log('[KEYCLOAK]', 'Update Token Triggered');
        this.keycloakService.updateToken(120).catch(() => {
          console.log('[KEYCLOAK]', 'Update Token Failed');
        });
      });
    }
    return Promise.resolve(loggedIn);
  }
  getQueryParameterByName(name) {
    // We are using this method because injecting activated Route here causes cyclic dependency.
    var match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}
}
